import React, { Fragment } from 'react';
import { IconButton, TooltipHost, DirectionalHint, Stack } from '@fluentui/react';
import ContentRightPanel from "./ContentRightPanel";
import { useSelector } from "react-redux";
import Layout from "../../Styles/Layout";
import { onCloseRightPanel, onMaximumPanel, onMinimizePanel } from "../../Containers/RightPanelAction";
import '../../Styles/tab.css'
import { GiaoThoaPolygon } from './../../Containers/GiaoCatPolygons';
const RightPanel = () => {
    const { className, isShow, routeContent, isMinimized, arrLabelShow } = useSelector(state => state.rightPanel)
    const heightScreenScroll = window.screen.width;
    
    return (
        isShow ?
            <Fragment  >
                {isMinimized === true ?
                    <div className="MaximumButton">
                        <TooltipHost
                            content={'Hiển thị thông tin'}
                            styles={{ root: { display: 'inline-block' } }}
                            directionalHint={DirectionalHint.bottomCenter}
                        >
                            <IconButton
                                iconProps={{ iconName: 'Favicon' }}
                                styles={styles.closeButton}
                                onClick={onMaximumPanel}
                            />
                        </TooltipHost>
                    </div>
                    : null}
                <div style={{ ...styles.modal(heightScreenScroll < 650), display: isMinimized === true ? 'none' : 'flex' }} className={className}>
                    <div className="tab">
                        {arrLabelShow.map(e => {
                            return (
                                <button className="tablinks" style={{ display: e.active === true ? 'block' : 'none' }} >{e.text}</button>
                            )
                        })}

                    </div>

                    <ContentRightPanel
                        route={routeContent}
                    />

                    <div style={styles.closeButtonView()}>
                        <TooltipHost
                            content={'Ẩn'}
                            styles={{ root: { display: 'inline-block' } }}
                            directionalHint={DirectionalHint.bottomCenter}
                        >
                            <IconButton
                                iconProps={{ iconName: 'Remove' }}
                                styles={styles.closeButton}
                                onClick={onMinimizePanel}
                            />
                        </TooltipHost>
                        {/* <TooltipHost
                            content={'Đóng'}
                            styles={{ root: { display: 'inline-block' } }}
                            directionalHint={DirectionalHint.bottomCenter}
                        >
                            <IconButton
                                iconProps={{ iconName: 'ChromeClose' }}
                                styles={styles.closeButton}
                                onClick={onCloseRightPanel}
                            />
                        </TooltipHost> */}
                    </div>
                </div>
            </Fragment>

            : null
    )
}

export default React.memo(RightPanel)


const styles = {
    modal: (isSmall) => ({
        height: 'calc(100vh - 48px)',
        width: Layout.panelWidth,
        position: 'relative',
        // display: 'flex',
        flexDirection: 'column',
        marginTop: isSmall ? 60 : 0
    }),
    closeButtonView: () => ({
        position: 'absolute',
        top: 1,
        left: 'calc(100% - 90px)',
    }),
    closeButton: {
        root: {
            height: 40,
            width: 40,
            borderRadius: 0,
            zIndex: 99
        },
        icon: {
            color: '#4C4A48',
            fontSize: 12
        },
        rootHovered: {
            backgroundColor: 'rgba(0,0,0,.1)'
        }
    }
};
